export enum Country {
  AU = 'au',
  DE = 'de',
  FR = 'fr',
  LU = 'lu',
  CH = 'ch',
  ES = 'es',
  IS = 'is',
  IC = 'ic',
  PT = 'pt',
  CZ = 'cz',
  NL = 'nl',
  BE = 'be',
  NO = 'no',
  DK = 'dk',
  CN = 'cn',
  JP = 'jp',
  KR = 'kr',
  TH = 'th',
  VN = 'vn',
  IN = 'in',
  AE = 'ae',
  PH = 'ph',
  ID = 'id',
  SE = 'se',
  LT = 'lt',
  FI = 'fi',
}
